// @flow
import React from 'react'
import I18n from 'i18n-react'
// core
import { getMessageFromValidationError } from '../../ContainerFunctions'

// types
import type { FieldValidationError } from '../../Types/ValidationError'

export type DefaultFormFieldDomainType = {
  [key: string]: any,
}

export type DefaultFormFieldType = {
  id: string,
  enabled: boolean,
  domain: DefaultFormFieldDomainType,
  debug?: boolean,
  formData: {
    [key: string]: any,
  },
  name: string,
  isRequired: boolean,
  isPristine: boolean,
  textMode?: boolean,
  valueNames?: {
    [key: string]: string,
  },
  onChange: Function,
  prefix: string,
  value: any,
  validationErrors?: FieldValidationError,
}

export type DefaultFormFieldState = {
  pristine: boolean,
  prevPropsValue: string,
  prevIsPristine: boolean,
  translationsLoaded: boolean,
}

export const checkStateIfNeedToUpdate = (nextState: Object, thisState: Object) =>
  Object.keys(nextState).reduce(
    (acc, key) => acc || JSON.stringify(nextState[key]) !== JSON.stringify(thisState[key]),
    false,
  )

export default class AbstractFormField<AbstractProps: Object, State: Object> extends React.PureComponent<
  AbstractProps,
  State,
> {
  constructor(props: AbstractProps) {
    super(props)
    this.state = {
      prevPropsValue: '',
      pristine: true,
      prevIsPristine: true,
      translationsLoaded: false,
    }
  }

  // todo poznamka
  static getDerivedStateFromProps(nextProps: AbstractProps, prevState: State) {
    if (
      !nextProps.isPristine !== !prevState.pristine &&
      nextProps.isPristine !== prevState.prevIsPristine &&
      !nextProps.isPristine
    ) {
      return {
        pristine: false,
        prevIsPristine: nextProps.isPristine,
      }
    }
    if (I18n.texts && I18n.texts.translationLoaded !== prevState.translationsLoaded) {
      return {
        translationsLoaded: I18n.texts.translationLoaded,
      }
    }
    return null
  }

  hasErrors = () => !!this.getErrors()

  getErrors = (): boolean | FieldValidationError => {
    const error: boolean | FieldValidationError = this.props.validationErrors
      ? this.props.validationErrors[this.props.name]
      : false
    if (error && error.error_type) {
      return error
    }
    return false
  }

  getErrorText = () => {
    let error = null
    const errors = this.getErrors()
    if (errors && typeof errors !== 'boolean') {
      error = getMessageFromValidationError(
        errors,
        `${this.props.prefix}${this.props.name}.`.replace(new RegExp('-', 'g'), '.'),
      )
    }
    if (!error) {
      return ''
    }
    return `${I18n.translate(`validationErrors.${error.msg}`, { ...this.props.templateVariables, ...error.data })}`
  }

  onBlur = (event: SyntheticInputEvent<HTMLInputElement>) => {
    if (this.props.onBlur && event && event.target) {
      this.props.onBlur(
        `${this.props.prefix}${this.props.name}`,
        event.target.value,
        [],
        `${event.target.value}` !== `${this.props.value}`,
      )
    }
    this.setState({ pristine: false })
  }

  isPristine = () => this.state.pristine

  hideError = () => {
    this.setState({ pristine: true })
  }

  renderError = (): Object => {
    return this.hasErrors() && !this.isPristine() ? this.renderErrorHtml() : null
  }

  renderErrorHtml = (): Object => {
    return (
      <div className="invalid-tooltip mt-0 cursor-pointer" onClick={this.hideError}>
        <span>{this.getErrorText()}</span>
      </div>
    )
  }

  render(): any {
    return (
      <p>
        Field not defined =&gt; {this.props.name}: {this.props.domain._type} ({this.props.component})
      </p>
    )
  }
}
